import { setAccessToken } from '../Account/actions'
import { setCookieToken } from '../utils/cookieToken'

export const CHECKOUT_API_URL = `${window.location.protocol}//api.${process.env.REACT_APP_MCP_HOST}`
export const getAccessToken = (accessToken) => async (dispatch) => {
  const URL = `${CHECKOUT_API_URL}/v3/access_token.json`
  const response = await fetch(URL, {
    method: 'GET',
    // credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'X-USER-ACCESS-TOKEN': accessToken,
    },
  }).then((res) => res.json()).catch((error) => {
    console.log(error)
  })
  dispatch(setAccessToken(response.access_token))
  setCookieToken(response.access_token)
}
